import assign from 'lodash.assign'

export const REQUEST_WP_PAGE_DATA_SUCCESS = 'REQUEST_WP_PAGE_DATA_SUCCESS'
export const REQUEST_WP_BLOG_POST_DATA_SUCCESS =
  'REQUEST_WP_BLOG_POST_DATA_SUCCESS'
export const REQUEST_WP_BLOG_POSTS_DATA_SUCCESS =
  'REQUEST_WP_BLOG_POSTS_DATA_SUCCESS'
export const REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS =
  'REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS'
export const REQUEST_WP_PRESS_POSTS_DATA_SUCCESS =
  'REQUEST_WP_PRESS_POSTS_DATA_SUCCESS'

const intialState = {
  pages: {},
  // NOTE: the absence of data is used as a loading indicator
  blogPosts: null,
  pressPosts: null,
  caseStudyPosts: null
}

// NOTE: the wp slug for case study pages is `/blog/{slug}`, but we serve them on `/case-studies/{slug}`
// so re-write them here
function formatCaseStudyPost (post) {
  let formattedPost = assign({}, post)
  if (formattedPost.link) {
    formattedPost.link = formattedPost.link.replace('/blog/', '/case-studies/')
  }
  return formattedPost
}

export default function wpData (state = intialState, action) {
  switch (action.type) {
    case REQUEST_WP_PAGE_DATA_SUCCESS:
      const newPages = assign({}, state.pages, {
        [action.page.id]: action.page
      })
      return assign({}, state, {
        pages: newPages
      })

    case REQUEST_WP_BLOG_POST_DATA_SUCCESS:
      const blogPostsWithNewPage = assign({}, state.blogPosts, {
        [action.blogPost.id]: action.blogPost
      })
      return assign({}, state, {
        blogPosts: blogPostsWithNewPage
      })

    case REQUEST_WP_BLOG_POSTS_DATA_SUCCESS:
      // comes as an array, whereas we want them as a byId Object
      const newBlogPosts = action.blogPosts.reduce((acc, blogPost) => {
        acc[blogPost.id] = blogPost
        return acc
      }, {})
      return assign({}, state, {
        blogPosts: newBlogPosts
      })

    case REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS:
      const newCaseStudyPosts = assign({}, state.caseStudyPosts, {
        [action.caseStudyPost.id]: formatCaseStudyPost(action.caseStudyPost)
      })
      return assign({}, state, {
        caseStudyPosts: newCaseStudyPosts
      })

    case REQUEST_WP_PRESS_POSTS_DATA_SUCCESS:
      // comes as an array, whereas we want them as a byId Object
      const newPressPosts = action.pressPosts.reduce((acc, pressPost) => {
        acc[pressPost.id] = pressPost
        return acc
      }, {})
      return assign({}, state, {
        pressPosts: newPressPosts
      })
    default:
      return state
  }
}

export function requestWpPageDataSuccess (page) {
  return {
    type: REQUEST_WP_PAGE_DATA_SUCCESS,
    page
  }
}

export function requestWpBlogPostDataSuccess (blogPost) {
  return {
    type: REQUEST_WP_BLOG_POST_DATA_SUCCESS,
    blogPost
  }
}

export function requestWpCaseStudyPostDataSuccess (caseStudyPost) {
  return {
    type: REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS,
    caseStudyPost
  }
}

export function requestWpBlogPostsDataSuccess (blogPosts) {
  return {
    type: REQUEST_WP_BLOG_POSTS_DATA_SUCCESS,
    blogPosts
  }
}

export function requestWpPressPostsDataSuccess (pressPosts) {
  return {
    type: REQUEST_WP_PRESS_POSTS_DATA_SUCCESS,
    pressPosts
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/wpData.js